import { createFeature, createReducer, on } from '@ngrx/store';

import { TokenActions } from './token.actions';

export interface TokenData {
  type: 'administrator';
  id: number;
  email: string;
}

export interface TokenState {
  tokenString: string | null;
  tokenData: TokenData | null;
  error: string | null;
}

export const initialState: TokenState = {
  tokenString: null,
  tokenData: null,
  error: null,
};

export const tokenFeature = createFeature({
  name: 'token',
  reducer: createReducer(
    initialState,
    on(TokenActions.loginSuccess, (state, { tokenString, tokenData }) => ({ ...state, tokenString, tokenData, error: null })),
    on(TokenActions.loginFailure, (state, { error }) => ({ ...state, token: null, tokenData: null, error: error.toString() })),
    on(TokenActions.logoutSuccess, () => ({ ...initialState })),
    on(TokenActions.logoutFailure, (state, { error }) => ({ ...state, error: error.toString() })),
    on(TokenActions.loadTokenSuccess, (state, { tokenString, tokenData }) => ({ ...state, tokenString, tokenData, error: null })),
    on(TokenActions.loadTokenFailure, (state, { error }) => ({ ...state, token: null, tokenData: null, error: error.toString() })),
  ),
});
